import React from "react";
import {IconProps} from "../../../../../icons/icon-props-interface";

const IconProfile: React.FC<IconProps> = ({color = 'var(--color-primary-2-50)'}) => {
    return (
        <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8 9C9.21242 9 10.3752 8.52589 11.2325 7.68198C12.0898 6.83807 12.5714 5.69347 12.5714 4.5C12.5714 3.30653 12.0898 2.16193 11.2325 1.31802C10.3752 0.474106 9.21242 0 8 0C6.78758 0 5.62482 0.474106 4.76751 1.31802C3.9102 2.16193 3.42857 3.30653 3.42857 4.5C3.42857 5.69347 3.9102 6.83807 4.76751 7.68198C5.62482 8.52589 6.78758 9 8 9ZM6.36786 10.6875C2.85 10.6875 0 13.493 0 16.9559C0 17.5324 0.475 18 1.06071 18H14.9393C15.525 18 16 17.5324 16 16.9559C16 13.493 13.15 10.6875 9.63214 10.6875H6.36786Z"
                fill={color}
            />
        </svg>
    );
}

export default IconProfile;